import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { Dimmer, Icon, Loader } from 'semantic-ui-react';

import { isEmpty } from '../../utils/lodash';
import {
  getActPreviewData,
  clearCurrentActivity,
  getReports,
  approvalToggleActivity,
  getReportViaEmail,
} from '../../store/actions';
import { ActivityPreviewSteps } from '../activities/library/preview';

// All Takso should never actually be empty.. so empty state should reflect error...
const EMPTY_STATE_COPY = {
  mine: {
    icon: 'folder open outline',
    title: 'Your library is currently empty...',
    body: 'Your activities will appear here once they have been completed.',
  },
  organisation: {
    icon: 'folder open outline',
    title: 'Nothing here yet...',
    body: 'There are currently no completed records across your organisation.',
  },
  platform: {
    icon: 'exclamation circle',
    title: 'Sorry something’s not right...',
    body: 'Try refreshing the page, or contact support if this continues.',
  },
};

class LibraryDetail extends PureComponent {
  componentDidMount() {
    this.fetchActivity();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activityId !== this.props.activityId) {
      this.fetchActivity();
    }
  }

  async fetchActivity() {
    const {
      activityId,
      getActPreviewData,
      clearCurrentActivity,
      onLoadingChange,
    } = this.props;
    if (!activityId) {
      onLoadingChange && onLoadingChange(false);
      return;
    }
    onLoadingChange && onLoadingChange(true);
    try {
      await clearCurrentActivity();
      await getActPreviewData(activityId);
    } catch (error) {
      // ActivityPreviewSteps renders nothing when currentActivity is empty
    } finally {
      onLoadingChange && onLoadingChange(false);
    }
  }

  render() {
    const {
      t,
      activityId,
      currentActivity,
      actGetLoading,
      scope,
      suppressOwnLoader,
    } = this.props;

    if (!activityId) {
      const copy = EMPTY_STATE_COPY[scope] || EMPTY_STATE_COPY.mine;
      return (
        <div className="lib-detail-empty">
          <Icon name={copy.icon} />
          <p className="lib-detail-empty__title">{copy.title}</p>
          <p className="lib-detail-empty__body">{copy.body}</p>
        </div>
      );
    }

    if (
      actGetLoading ||
      isEmpty(currentActivity) ||
      currentActivity.id !== activityId
    ) {
      if (suppressOwnLoader) return null;
      return (
        <Dimmer active inverted className="lib-detail-loading">
          <Loader active>{t('common.loading')}…</Loader>
        </Dimmer>
      );
    }

    return <ActivityPreviewSteps {...this.props} publicView />;
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    evidenceTypes: state.extra.evidenceTypes,
    parentOutcomes: state.extra.outcomes,
    festivalTypes: state.extra.festivalTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getActPreviewData,
      clearCurrentActivity,
      getReports,
      approvalToggleActivity,
      getReportViaEmail,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(LibraryDetail));
